import React from 'react';
import PageHeader from '../../components/PageHeader';
import { BRAND_NAME } from '../../utils/brand';

function Terms() {
  return (
    <>
      <PageHeader title="Terms & Conditions" subtitle="Last updated: 2026-05-08" />
      <div className="card prose">
        <h3>1. Nature of the platform</h3>
        <p>
          {BRAND_NAME} is a marketplace that connects patients to licensed
          clinics offering GLP-1 / GIP weight-management treatments.
          {BRAND_NAME} is <strong>not a medical provider</strong>. We do not
          prescribe, diagnose, or administer treatments. All medical services
          on the platform are provided by independently licensed clinics
          and Malaysian Medical Council (MMC)-registered doctors holding a
          valid Annual Practicing Certificate (APC).
        </p>

        <h3>2. Eligibility</h3>
        <p>
          Treatment eligibility is determined by a clinical assessment that
          includes our screening quiz and a final review by the licensed
          doctor at your selected clinic. The platform may filter or block
          bookings based on contraindications surfaced in the quiz.
        </p>

        <h3>3. Bookings, payments and cancellations</h3>
        <p>
          Bookings are confirmed once your deposit clears. The remaining
          balance is payable at the clinic. Refund and cancellation rules
          are governed by the clinic you book with; check their policy
          before paying. We will assist in good-faith dispute resolution
          but ultimate responsibility for clinical care, refunds, and
          adverse events lies with the clinic.
        </p>

        <h3>4. Use of the platform</h3>
        <p>
          You agree not to: provide false health information; use another
          person's identity; attempt to reverse-engineer the platform; use
          referral mechanics fraudulently. Violations may result in account
          suspension and forfeiture of unused credits or rewards.
        </p>

        <h3>5. Limitation of liability</h3>
        <p>
          Treatment results vary per individual. The platform makes no
          guarantee of outcomes. To the fullest extent permitted by law,
          {BRAND_NAME}'s liability is limited to fees paid to {BRAND_NAME} for
          the affected booking.
        </p>

        <h3>6. Updates</h3>
        <p>
          We may update these terms. Continued use after an update means
          you accept the revised terms.
        </p>
      </div>
    </>
  );
}

export default Terms;
